/*
/*
akhila 11/01/2022 3075154998 TablePagination bugFix
saikrishna 11/03/2022 3075154998 changed the paginationOptions

*/
import React, {createRef, useEffect, useState} from 'react';
// import MaterialTable from "material-table";
import {Grid, TablePagination} from '@material-ui/core';
import {tableIcons} from '../../../.../../../../../components/TableIcons';
import {defaultRows} from '../../../.../../../../../constants/ReusableTablePagination';
import {httpPaginationPost} from '../../../.../../../../../util/Rest';
import {useDispatch} from 'react-redux';
import GuiTable from '../../../../../../components/FormComponents/GuiTable';
import {tablePageRows} from '../../../../../../constants/ReusableConstants';

export default function FilterGroupSearchTable({
  setSelectedFilterGroupCode,
  searchData,
  setTabValue,
  submit,
  setSubmit,
  handleClose,
  setRecordFormatFilterGroupCode,
  setFilterGroupCode,
  setSelectedRows,
  selectedRows,
}) {
  const columns = [
    {
      title: 'Record Format Code',
      field: 'recordFormatCode',
    },
    {
      title: 'Record Format Description',
      field: 'description',
    },
    {
      title: 'File Type',
      field: 'type',
    },
    {
      title: 'Record Format Type',
      field: 'frameWorkType',
      render: (rowData) =>
        rowData?.frameWorkType === 'Enable' ?
          'Enable File Format' :
          rowData?.frameWorkType === 'RecordFormat' ?
            'Report Record Format' :
            '',
    },
  ];

  const tableRef = createRef();
  const [rows, setRows] = useState(defaultRows);
  const [arrayLast, setArrayLast] = useState(false);
  const dispatch = useDispatch();
  useEffect(() => {
    if (tableRef?.current) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [searchData]);
  return (
    <>
      <Grid item xs={12} className="">
        <div className="custom-table global-field-table ">
          <GuiTable
            title=""
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            data={(query) =>
              new Promise((resolve) => {
                const url = `recordFormat/search/all`;
                const bodyObj = {
                  recordFormatCode: searchData?.code ? searchData.code : '',
                  frameWorkType: 'Enable',
                  description: searchData?.description ? searchData.description : '',
                  type: searchData?.fileType ? searchData.fileType?.value : '',
                  limit: query.pageSize ? query.pageSize : null,
                  page: submit ?
                    1 :
                    arrayLast && query.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                };
                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj).then((response) => {
                    if (response?.status === 200) {
                      const newObj = {};
                      selectedRows?.forEach((el) => {
                        if (!newObj[el.recordFormatCode]) {
                          newObj[el.recordFormatCode] = el;
                        }
                      });
                      const newRow = response.data.response.resultObjects.map((elem) => {
                        if (newObj[elem.recordFormatCode]) {
                          return {...elem, tableData: {...elem.tableData, checked: true}};
                        } else {
                          return {
                            ...elem,
                            tableData: {...elem.tableData, checked: false},
                          };
                        }
                      });
                      resolve({
                        data: newRow.length > 0 ? newRow : [],
                        page: response.data.response.page - 1,
                        totalCount: response.data.response.count,
                      });
                      setArrayLast(response.data.response.resultObjects.length === 1);
                      setSubmit(false);
                    } else {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    }
                  })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              toolbar: false,
              search: false,
              selection: true,
              pageSize: rows,
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            components={{
              Pagination: (props) => (
                <TablePagination
                  {...props}
                  SelectProps={{
                    inputProps: {'aria-label': 'Rows per screen'},
                  }}
                  labelRowsPerPage={'Rows per screen:'}
                  rowsPerPageOptions={tablePageRows}
                  onChangeRowsPerPage={(event) => {
                    props.onChangeRowsPerPage(event);
                    setRows(event.target.value);
                  }}
                />
              ),
            }}
            onSelectionChange={(rows, unSelected) => {
              if (unSelected?.tableData?.checked) {
                setSelectedRows([...selectedRows, unSelected]);
              } else {
                const updatedRows = [...selectedRows]
                  .filter((ele) => ele.recordFormatCode !== unSelected.recordFormatCode)
                  .map((ele) => {
                    return {...ele, tableData: {...ele.tableData, id: ele.globalField}};
                  });
                setSelectedRows(updatedRows);
              }
            }}
          />
        </div>
      </Grid>
    </>
  );
}
